export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ko": {
        "FORM_MSG_CONTENTS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["내용을 입력해주세요."])}
      },
      "en": {
        "FORM_MSG_CONTENTS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please enter the contents."])}
      }
    }
  })
}
